document.addEventListener('DOMContentLoaded', async () => {
  const config = window.manualsFiltersConfig || {};
  const sectionId = config.pageData.sectionId;
  const brandsModelsData = parseJsonSafe(decodeQuotes(config.pageData.brandsModelsDataRaw))[0];
  const iconCart = config.pageData.iconCart;

  const brandSelect = document.getElementById(`brand-select-${sectionId}`);
  const modelSelect = document.getElementById(`model-select-${sectionId}`);
  const brandOptions = brandSelect.querySelector('.custom-options');
  const modelOptions = modelSelect.querySelector('.custom-options');

  function showLoadingSpinner(selectElement) {
    selectElement.classList.add('loading');
    const trigger = selectElement.querySelector('.custom-select-trigger');
    trigger.textContent = 'Loading...';
  }

  function hideLoadingSpinner(selectElement) {
    selectElement.classList.remove('loading');
  }

  function getSelectedBrandFromURL() {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    return pathParts.length > 2 ? pathParts[pathParts.length - 1] : null;
  }

  function getSelectedModelFromURL() {
    const params = new URLSearchParams(window.location.search);
    const encodedModel = params.get('model');

    if (!encodedModel) return null;

    const decodedModel = decodeURIComponent(encodedModel);
    return decodedModel;
  }
  async function getModelsByBrand(selectedBrand) {
    let models = brandsModelsData[selectedBrand.toLowerCase()] || [];

    if (!models.length && selectedBrand) {
      models = await fetchMetaobjectModelsByBrand(selectedBrand);
    }

    return models; // Return full model objects with name, image, manuals
  }

  function getModelsFavourite() {
    const models = parseJsonSafe(decodeQuotes(config.pageData.favouriteModelsDataRaw));
    return models; // Return full model objects with name, image, manuals
  }

  function getManualsBase() {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const pagesIndex = pathParts.indexOf('pages');
    console.log(pagesIndex);

    if (pagesIndex >= 0) {
      const beforePages = pagesIndex === 1 ? pathParts.slice(0, 1) : [];
      const afterPages = pathParts.slice(pagesIndex, pagesIndex + 2);
      console.log(afterPages);
      const baseParts = beforePages.concat(afterPages);
      return '/' + baseParts.join('/');
    }

    // Fallback
    return '/pages/manuals';
  }

  function displayModels(modelsData) {
    document.getElementById('manuals-single-phone-container').style.display = 'none';
    const spinner = document.getElementById('loadingSpinner');
    if (spinner) spinner.style.display = 'none';

    const modelsContainer = document.getElementById('modelListContainer');
    if (!modelsContainer) return;

    const pathParts = window.location.pathname.split('/').filter(Boolean);
    // const manualsBase = pathParts.length >= 2 ? `/${pathParts.slice(0, 2).join('/')}` : '/pages/manuals';

    const manualsBase = getManualsBase();
    console.log(manualsBase);

    modelsContainer.innerHTML = '';
    const ulElement = document.createElement('ul');
    ulElement.classList.add('model-list');

    modelsData.forEach(model => {
      const modelHandle = encodeURIComponent(model.name);

      const brandHandle = model.vendor ? model.vendor.toLowerCase().replace(/\s+/g, '-') : 'unknown';
      const linkHref = `${manualsBase}/${brandHandle}?model=${modelHandle}`;

      const liElement = document.createElement('li');
      liElement.classList.add('model-item');

      const aElement = document.createElement('a');
      aElement.href = linkHref;
      aElement.classList.add('model-item-box');

      const spanElement = document.createElement('span');
      spanElement.classList.add('model-name');
      spanElement.textContent = model.name;

      const imgElement = document.createElement('img');
      imgElement.classList.add('model-image');
      imgElement.src = model.image || 'https://via.placeholder.com/150';
      imgElement.alt = model.name;
      imgElement.loading = 'lazy';

      aElement.appendChild(imgElement);
      aElement.appendChild(spanElement);
      liElement.appendChild(aElement);
      ulElement.appendChild(liElement);
    });

    modelsContainer.appendChild(ulElement);
  }

  async function getSelectedModelData(selectedModel, selectedBrand, models) {
    const modelData = models.find(m =>
      m.name.toLowerCase() === selectedModel.toLowerCase()
    );
    return modelData;
  }

  function populateModelTemplate(modelData) {
    if (!modelData) return;
    document.getElementById('manuals-single-phone-container').style.display = 'block';

    const manualsGuidesList = document.querySelector(".manuals-guides-list");
    manualsGuidesList.innerHTML = "";
    // Populate manuals
    modelData.manuals.forEach((url) => {
      const fileName = url.split("/").pop().split("?")[0];
      const displayName = fileName.replace(".pdf", "").replace(/_/g, " ");
      const li = document.createElement("li");
      li.className = "manual-item";
      li.innerHTML = `
      <a href="#" class="manual-download-link" data-url="${url}" data-filename="${fileName}">
         <img src="${config.pageData.downloadIcon}" class="manual-image" alt="Manuals Download" loading="lazy">
         <div class="item-name">
            <h2 class="main-title">
              ${config.translations.manual}
            </h2>
            <h4>
              ${displayName}
            </h4>
         </div>
      </a>
    `;
      manualsGuidesList.appendChild(li);
    });

    modelData.manualsProfessional.forEach((url) => {
      const fileName = url.split("/").pop().split("?")[0];
      const displayName = fileName.replace(".pdf", "").replace(/_/g, " ");
      const li = document.createElement("li");
      li.className = "manual-item";
      li.innerHTML = `
      <a href="#" class="manual-download-link" data-url="${url}" data-filename="${fileName}">
         <img src="${config.pageData.downloadIcon}" class="manual-image" alt="Manuals Download" loading="lazy">
         <div class="item-name">
            <h2 class="main-title">
              ${config.translations.manual}
            </h2>
            <h5 class="second-title">
              ${config.translations.manual_professional}
            </h5>
            <h4>
              ${displayName}
            </h4>
         </div>
      </a>
    `;
      manualsGuidesList.appendChild(li);
    });

    //Populate repair guides
    if(modelData.repairGuides){
      modelData.repairGuides.forEach((guide, index) => {
        const li = document.createElement("li");
        li.className = "repair-guide-item";
        li.innerHTML = `<a href="#" class="repair-guide-link" data-index="${index}" data-id="${guide.id}">
         <img src="${guide.image}" class="manual-image" alt="${guide.name}" loading="lazy">
         <div class="item-name">
            <h2 class="main-title">
              ${guide.name}
            </h2>
            <h4>
              ${modelData.name}
            </h4>
         </div>
      </a>`;
        manualsGuidesList.appendChild(li);
      });
    }
  }

  function showGuideDetails(guide) {

    const container = document.querySelector(".manuals-single-phone-guide-container");
    container.style.display = "block";

    const titleContainer = container.querySelector(".manuals-single-phone-title");
    titleContainer.innerHTML = `<h2> ${guide.name} </h2>`;

    // Service Tools
    loadProductCards(guide.serviceTools, ".tools-list");

    // Replacement Devices (Parts)
    loadProductCards(guide.replacementDevices, ".parts-list");

    // Intro
    const introHtml = renderRichText( JSON.parse(guide.intro));
    container.querySelector(".intro-content").innerHTML = introHtml;

    //Video
    const videoContainer = container.querySelector(".video-content");
    videoContainer.innerHTML = ""; // Clear previous content

    if (guide.video) {
      videoContainer.innerHTML = getVideoHtml(guide.video);
    }

    // Steps
    const stepsList = container.querySelector(".steps-list");
    stepsList.innerHTML = "";
    guide.steps.forEach((step, index) => {
      const li = document.createElement("li");

      //Title
      const stepTitle = document.createElement("h3");
      const stepTitleindex = document.createElement("strong");
      stepTitleindex.textContent =`${config.translations.step} 0${index + 1}`;
      stepTitle.appendChild(stepTitleindex);
      stepTitle.appendChild(document.createTextNode(` ${step.title}`));
      li.appendChild(stepTitle);

      //Description
      const stepDesc = document.createElement("p");
      const stepHtml = renderRichText( JSON.parse(step.description));
      stepDesc.innerHTML = stepHtml;
      li.appendChild(stepDesc);

      //Images
      if (step.images && step.images.length > 0) {
        const imagesContainer = document.createElement("div");
        imagesContainer.classList.add("step-images");

        step.images.forEach((url) => {
          const img = document.createElement("img");
          img.src = url;
          img.alt = step.title || "Step image";
          imagesContainer.appendChild(img);
        });

        li.appendChild(imagesContainer);
      }

      //Video
      const stepVideoContainer = document.createElement("div");
      if (step.stepVideo) {
        stepVideoContainer.innerHTML = getVideoHtml(step.stepVideo);
        li.appendChild(stepVideoContainer);
      }

      stepsList.appendChild(li);
    });
  }

  function getVideoHtml(video) {
    let videoHtml = "";

    if (video.type === "youtube") {
      const videoId = video.id;
      videoHtml = `
      <div class="manual-video-wrapper centered-video">
        <iframe
          width="100%"
          height="480"
          src="https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
        ></iframe>
      </div>`;
    } else if (video.type === "file") {
      const videoUrl = video.url;
      videoHtml = `
      <div class="manual-video-wrapper centered-video">
        <video controls width="100%" height="auto">
          <source src="${videoUrl}" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>`;
    }

    return videoHtml;
  }

  async function loadProductCards(products, containerSelector = '#ProductCardLoader') {
    if (!products || products.length === 0) return;

    const container = document.querySelector(containerSelector);
    if (!container) return;
    const cartIconSVG = await loadSVG(iconCart); // Adjust path if needed

    const cardsHTML = products.map(product => {
      const isAvailable = product.quantityAvailable > 0 ? true : false;
      const variantId = product.variantId;
      const buttonDisabled = !isAvailable ? 'disabled' : '';
      const imageUrl = product.imageUrl ? product.imageUrl : '/cdn/shop/t/8/assets/no_photo.jpg';
      const imageAlt = product.imageAlt || 'No image available';

      return `
                  <li>
                    <div class="card-wrapper product-card-wrapper">
                      <div class="card card--standard card--media" style="--ratio-percent: 100%;">
                        <div class="card__inner">
                          <div class="card__media">
                            <div class="media media--transparent">
                              <img src="${imageUrl}" alt="${imageAlt}" class="motion-reduce" loading="lazy" width="533" height="533">
                            </div>
                          </div>
                
                          <div class="card__content">
                            <div class="card__badge">
                              ${parseFloat(product.compareAtPrice) > parseFloat(product.price) ? `<span class="badge badge--bottom-left">On Sale</span>` : ''}
                            </div>
                          </div>
                        </div>
                
                        <div class="card__content">
                          <div class="card__information">
                            <h3 class="card__heading h5">
                              <a href="${product.url}" class="full-unstyled-link">${product.title}</a>
                            </h3>
                            <div class="product-extra-info">
                              <div class="caption-with-letter-spacing light">${product.vendor}</div>
                              ${renderInventoryInfo(product.quantityAvailable)}
                            </div>
                          </div>
                          <div class="card__information">
                              <div class="card-price-cart-container">
                                <div class="price">
                                  <div class="price-container">
                                  ${product.price} ${product.currency}
                                  </div>
                                </div>
                                ${parseFloat(product.compareAtPrice) > parseFloat(product.price) ? `<span class="compare-price">$${product.compareAtPrice}</span>` : ''}
                              </div>
                                <!-- Quick Add Form -->
                                <div class="card-quick-add">
                                  <button
                                    class="quick-add__submit button button--full-width button--secondary"
                                    data-variant-id="${variantId}"
                                    data-quantity="1"
                                    aria-live="polite"
                                    ${buttonDisabled}
                                  >
                                    <span>${cartIconSVG}</span>
                                  </button>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </li>
                `
    }).join('');

    container.innerHTML = cardsHTML;
  }

  async function addToCart(variantId, quantity = 1) {
    try {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add item to cart');
      }

      const cartItem = await response.json();

      // Optionally: Update the cart UI, open cart drawer, show notification, etc.
      updateCartNotification(cartItem);
      updateCartIcon();

      return cartItem; // Return added item data if needed
    } catch (error) {
      console.error('Add to cart error:', error);
      showAddToCartError(error.message);
    }
  }

  async function updateCartIcon() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;

      // Update visible count
      const bubble = document.querySelector('.cart-count-bubble');

      if (!bubble && count > 0) {
        const headerIconCart = document.querySelector('#cart-icon-bubble');

        if (!headerIconCart) return;

        // Create the bubble
        const newbubble = document.createElement('div');
        newbubble.className = 'cart-count-bubble';

        const visibleCount = document.createElement('span');
        visibleCount.setAttribute('aria-hidden', 'true');
        visibleCount.textContent = count;

        const hiddenCount = document.createElement('span');
        hiddenCount.className = 'visually-hidden';
        hiddenCount.textContent = `${count} articole`;

        newbubble.appendChild(visibleCount);
        newbubble.appendChild(hiddenCount);

        // Append to header (or wherever it belongs)
        headerIconCart.appendChild(newbubble);
        headerIconCart.querySelector(".cls-1c").style.fill = "#666666";
      }

      if (bubble) {
        const visibleCount = bubble.querySelector('span[aria-hidden="true"]');
        const hiddenCount = bubble.querySelector('.visually-hidden');

        if (visibleCount) visibleCount.textContent = count;
        if (hiddenCount) hiddenCount.textContent = `${count} articole`;

        // Show or hide bubble based on count
        if (count > 0) {
          bubble.classList.remove('hidden');
        } else {
          bubble.classList.add('hidden');
        }
      }
    } catch (error) {
      console.error('Error updating cart icon:', error);
    }
  }

  function updateCartNotification(cartItem) {
    const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartNotification) {
      // Call a method to update the cart notification drawer content (implementation depends on your codebase)
      if (typeof cartNotification.update === 'function') {
        cartNotification.update(); // Or your custom logic to refresh cart UI
      }
      // Optionally open the cart drawer or show confirmation
      if (typeof cartNotification.open === 'function') {
        cartNotification.open();
      }
    } else {
      alert('Added to cart: ' + cartItem.product_title); // fallback alert
    }
  }

  function showAddToCartError(message) {
    // Display error in modal or UI. Customize as needed.
    alert('Error adding to cart: ' + message);
  }

  function renderInventoryInfo(inventoryQuantity) {
    const quantity = parseInt(inventoryQuantity);

    const threshold = 5; // Low stock threshold

    if (quantity > 0) {
      const isLow = quantity <= threshold;

      const color = isLow ? 'rgb(238,148,65)' : 'rgb(62,214,96)';
      const bg = isLow ? 'rgba(238,148,65,0.3)' : 'rgba(62,214,96,0.3)';
      const translation = isLow
        ? config.translations?.inventory_low_stock?.replace('{{ quantity }}', quantity)
        : config.translations?.inventory_in_stock;

      return `
      <p class="product__inventory">
        <svg width="15" height="15" aria-hidden="true">
          <circle cx="7.5" cy="7.5" r="7.5" fill="${bg}"/>
          <circle cx="7.5" cy="7.5" r="5" stroke="#fff" stroke-width="1" fill="${color}"/>
        </svg>
        <span style="color:${color}">${translation}</span>
      </p>
    `;
    } else {
      return `
        <p class="product__inventory">
          <svg width="15" height="15" aria-hidden="true">
            <circle cx="7.5" cy="7.5" r="7.5" fill="rgba(200,200,200,0.3)"/>
            <circle cx="7.5" cy="7.5" r="5" stroke="#fff" stroke-width="1" fill="rgb(200,200,200)"/>
          </svg>
          <span style="color:rgb(200,200,200)">${config.translations?.inventory_out_of_stock}</span>
        </p>
      `;

    }
  }

  async function updateSelectedModel (selectedBrand, selectedModel, models) {
    const containerGuide = document.querySelector(".manuals-single-phone-guide-container");
    containerGuide.style.display = "none";

    const selectedOption = modelOptions.querySelector(`.custom-option[data-value="${selectedModel}"]`);
    if (selectedOption) {
      selectedOption.classList.add('selected');
      const selectedModelName = selectedModel
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase());
      document.getElementById(`model-select-value-${sectionId}`).textContent = selectedModelName;
      document.getElementById(`model-select-value-${sectionId}`).dataset.value = selectedModel;
      document.getElementById('modelListContainer').style.display = 'none';

      const modelData = await getSelectedModelData(selectedModelName, selectedBrand, models);
      if (modelData) {
        populateModelTemplate(modelData);
      }
  }
  }

  async function updateModels(selectedBrand, sectionId) {

    const modelSelect = document.getElementById(`model-select-${sectionId}`);
    const customOptions = modelSelect.querySelector('.custom-options');

    modelSelect.classList.remove('open');
    customOptions.innerHTML = '';
    showLoadingSpinner(modelSelect);
    modelSelect.classList.remove('disabled');

    try {
      if (selectedBrand) {
        const models = await getModelsByBrand(selectedBrand);
        document.getElementById('modelListContainer').style.display = 'block';
        displayModels(models);
        const filteredModels = models.map(model => model.name);
        hideLoadingSpinner(modelSelect);
        document.getElementById(`model-select-value-${sectionId}`).textContent = config.translations.selectModel;

        const pathParts = window.location.pathname.split('/').filter(Boolean);
        // const manualsBase = pathParts.length >= 2 ? `/${pathParts.slice(0, 2).join('/')}` : '/pages/manuals';
        const manualsBase = getManualsBase();
        const brandHandle = selectedBrand.toLowerCase().replace(/\s+/g, '-');

        filteredModels.forEach(model => {
          const modelHandle = encodeURIComponent(model);
          const li = document.createElement('li');
          li.className = 'custom-option';
          li.dataset.value = model;
          li.innerHTML = `<a href="${manualsBase}/${brandHandle}?model=${modelHandle}" class="option-link">${model}</a>`;
          customOptions.appendChild(li);
        });

        modelSelect.classList.remove('open');
        const trigger = modelSelect.querySelector('.custom-select-trigger');
        const searchInput = modelSelect.querySelector('.search-input');
        const optionsList = modelSelect.querySelector('.custom-options');
        trigger.style.display = 'block';
        searchInput.style.display = 'none';
        optionsList.style.display = 'none';
        const selectedModel = getSelectedModelFromURL();
        if (selectedModel) {
          await updateSelectedModel(selectedBrand, selectedModel, models);
        }

      } else {
        modelSelect.classList.add('disabled');
        hideLoadingSpinner(modelSelect);
        document.getElementById(`model-select-value-${sectionId}`).textContent = config.translations.selectModel;
        const modelsContainer = document.getElementById('modelListContainer');
        if (modelsContainer) modelsContainer.innerHTML = '';
      }
    } catch (error) {
      console.error('Failed to load models:', error);
      hideLoadingSpinner(modelSelect);

      const spinner = document.getElementById('loadingSpinner');
      if (spinner) spinner.textContent = 'Failed to load models.';
    }
  }

  async function initializeFilters() {

    const selectedBrand = getSelectedBrandFromURL();
    if (selectedBrand) {
      const selectedOption = brandOptions.querySelector(`.custom-option[data-value="${config.pageData.brandName}"]`);
      if (selectedOption) {
        selectedOption.classList.add('selected');
        document.getElementById(`brand-select-value-${sectionId}`).textContent = config.pageData.brandName;
        document.getElementById(`brand-select-value-${sectionId}`).dataset.value = config.pageData.brandName;
        await updateModels(selectedBrand, sectionId);

      }
    } else {
      const favoriteModels =  getModelsFavourite();
      displayModels(favoriteModels);
      document.getElementById(`model-select-${sectionId}`).classList.add('disabled');
    }

  }

  window.addEventListener('popstate', async () => {
    const selectedBrand = getSelectedBrandFromURL();
    if (selectedBrand) {
      document.getElementById('modelListContainer').style.display = 'block';
      document.getElementById('manuals-single-phone-container').style.display = 'none';
      const selectedOption = brandOptions.querySelector(`.custom-option[data-value="${selectedBrand}"]`);
      if (selectedOption) {
        brandOptions.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
        selectedOption.classList.add('selected');
        document.getElementById(`brand-select-value-${sectionId}`).textContent = selectedBrand;
        document.getElementById(`brand-select-value-${sectionId}`).dataset.value = selectedBrand;
      }
      await updateModels(selectedBrand, sectionId);
    } else {
      brandOptions.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
      document.getElementById(`brand-select-value-${sectionId}`).textContent = config.translations.selectBrand;
      document.getElementById(`brand-select-value-${sectionId}`).dataset.value = '';
      modelSelect.classList.add('disabled');
      modelSelect.querySelector('.custom-options').innerHTML = '';
      document.getElementById(`model-select-value-${sectionId}`).textContent = config.translations.selectModel;
      const modelsContainer = document.getElementById('modelListContainer');
      if (modelsContainer) modelsContainer.innerHTML = '';
      // Clear displayed models and show favourites
      const favoriteModels =  getModelsFavourite();
      displayModels(favoriteModels);
    }
  });

  document.querySelectorAll('.custom-select .search-input').forEach(input => {
    input.addEventListener('input', e => {
      const select = e.target.closest('.custom-select');
      filterOptions(select, e.target.value.toLowerCase());
    });
  });


  document.addEventListener('click', async e => {

    const addToCartButton = e.target.closest('.quick-add__submit');
    if(addToCartButton) {
      e.preventDefault();

      const gid = addToCartButton.dataset.variantId;
      const numericId = gid.split('/').pop();
      const quantity = parseInt(addToCartButton.dataset.quantity, 10) || 1;

      // Call your addToCart function
      await addToCart(numericId, quantity);
    }

    const repairGuideLink = e.target.closest('.repair-guide-link');
    if(repairGuideLink) {
      e.preventDefault();

      const selectedLi = repairGuideLink.closest('li');
      const allListItems = selectedLi.parentElement.querySelectorAll('li');
      allListItems.forEach(li => li.classList.remove('selected'));
      selectedLi.classList.add('selected');

      const guideId = repairGuideLink.dataset.id;
      const repairGuideData = await fetchRepairGuideById(guideId, config.pageData.shopLanguage);
      showGuideDetails(repairGuideData);
    }

    const downloadLink =  e.target.closest('.manual-download-link');
    if(downloadLink) {
      e.preventDefault();
      const url = downloadLink.dataset.url;
      const fileName = downloadLink.dataset.filename;

      if(url) {
        fetch(url)
          .then(response => response.blob())
          .then(blob => {
            const tempLink = document.createElement('a');
            tempLink.href = window.URL.createObjectURL(blob);
            tempLink.setAttribute('download', fileName || '');
            tempLink.click();
            window.URL.revokeObjectURL(tempLink.href);
          })
          .catch(error => console.error("Download failed:", error));
        }
    }

    const button = e.target.closest('#clear-btn-filter');
    if (button) {
      e.preventDefault();
      document.getElementById('modelListContainer').style.display = 'block';
      document.getElementById('manuals-single-phone-container').style.display = 'none';

      const pathParts = window.location.pathname.split('/').filter(Boolean);
      // const manualsBase = pathParts.length >= 2 ? `/${pathParts.slice(0, 2).join('/')}` : '/pages/manuals';
      const manualsBase = getManualsBase();
      const newUrl = manualsBase;
      window.history.pushState({}, '', newUrl);

      // Clear brand selection
      brandOptions.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
      document.getElementById(`brand-select-value-${sectionId}`).textContent = config.translations.selectBrand;
      document.getElementById(`brand-select-value-${sectionId}`).dataset.value = '';

      // Clear model selection and disable model dropdown
      modelOptions.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
      document.getElementById(`model-select-value-${sectionId}`).textContent = config.translations.selectModel;
      document.getElementById(`model-select-value-${sectionId}`).dataset.value = '';
      modelSelect.classList.add('disabled');
      modelSelect.querySelector('.custom-options').innerHTML = '';

      // Clear displayed models and show favourites
      const favoriteModels =  getModelsFavourite();
      displayModels(favoriteModels);
    }

    const trigger = e.target.closest('.custom-select-trigger');
    if (trigger) {

      const select = trigger.closest('.custom-select');
      if (!select.classList.contains('disabled')) {
        const searchInput = select.querySelector('.search-input');
        const optionsList = select.querySelector('.custom-options');
        closeAllSelects();
        select.classList.add('open');
        trigger.style.display = 'none';
        searchInput.style.display = 'block';
        optionsList.style.display = 'block';
        searchInput.value = '';
        filterOptions(select, '');
        searchInput.focus();
        const selectedModel = getSelectedModelFromURL();
        if (selectedModel) {
          const selectedModelName = selectedModel
            .replace(/[-_]/g, ' ')
            .replace(/\b\w/g, c => c.toUpperCase());
          filterModelDisplayed(selectedModelName, true);
        }
      }
      return;
    }

    const option = e.target.closest('.custom-option');
    if (option) {

      e.preventDefault()
      const select = option.closest('.custom-select');
      const trigger = select.querySelector('.custom-select-trigger');
      const searchInput = select.querySelector('.search-input');
      const optionsList = select.querySelector('.custom-options');

      trigger.textContent = option.textContent;
      trigger.dataset.value = option.dataset.value;
      trigger.style.display = 'block';
      searchInput.style.display = 'none';
      optionsList.style.display = 'none';

      select.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
      option.classList.add('selected');
      select.classList.remove('open');

      if (select.id === `brand-select-${sectionId}`) {

        const selectedBrand = option.dataset.value;
        brandOptions.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');
        document.getElementById(`brand-select-value-${sectionId}`).textContent = selectedBrand;
        document.getElementById(`brand-select-value-${sectionId}`).dataset.value = selectedBrand;
        const newUrl = e.target.closest('a').getAttribute('href');
        window.history.pushState({}, '', newUrl);
        updateModels(selectedBrand, sectionId);
      }

      if(select.id === `model-select-${sectionId}`) {

        const containerGuide = document.querySelector(".manuals-single-phone-guide-container");
        containerGuide.style.display = "none";

        const selectedBrand = getSelectedBrandFromURL();
        const selectedModel = option.dataset.value;
        const modelSelect = document.getElementById(`model-select-${sectionId}`);
        const customOptions = modelSelect.querySelector('.custom-options');
        customOptions.querySelectorAll('.custom-option').forEach(opt => opt.classList.remove('selected'));
        option.classList.add('selected');

        const selectedModelName = selectedModel
          .replace(/[-_]/g, ' ')
          .replace(/\b\w/g, c => c.toUpperCase());

        document.getElementById(`model-select-value-${sectionId}`).textContent = selectedModelName;
        document.getElementById(`model-select-value-${sectionId}`).dataset.value = selectedModel;

        modelSelect.classList.remove('open');

        const trigger = modelSelect.querySelector('.custom-select-trigger');
        const searchInput = modelSelect.querySelector('.search-input');
        trigger.style.display = 'block';
        searchInput.style.display = 'none';

        const newUrl = e.target.getAttribute('href');
        window.history.pushState({}, '', newUrl);

        document.getElementById('modelListContainer').style.display = 'none';

        const models = await getModelsByBrand(selectedBrand);
        const modelData = await getSelectedModelData(selectedModelName, selectedBrand, models);
        if (modelData) {
          populateModelTemplate(modelData);
        }
      }
      return;
    }

    if (!e.target.classList.contains('search-input')) {
      closeAllSelects();
    }
  });

  function filterOptions(select, searchTerm) {
    select.querySelectorAll('.custom-option').forEach(option => {
      option.classList.toggle('hidden', !option.textContent.toLowerCase().includes(searchTerm));
    });
    filterModelDisplayed(searchTerm, false);
  }
  function closeAllSelects() {
    document.querySelectorAll('.custom-select').forEach(select => {
      select.classList.remove('open');
      const trigger = select.querySelector('.custom-select-trigger');
      const searchInput = select.querySelector('.search-input');
      const optionsList = select.querySelector('.custom-options');
      if (trigger) trigger.style.display = 'block';
      if (searchInput) searchInput.style.display = 'none';
      if (optionsList) optionsList.style.display = 'none';
    });
  }

  function filterModelDisplayed(searchTerm, exact) {
    const modelItems = document.querySelectorAll('.model-item');
    const normalizedSearch = searchTerm.trim().toLowerCase();

    modelItems.forEach(item => {
      const modelName = item.querySelector('.model-name').textContent.trim().toLowerCase();
      const match = exact
        ? modelName === normalizedSearch
        : modelName.includes(normalizedSearch);

      item.style.display = match ? 'block' : 'none';
    });
  }

  await initializeFilters();
});